<template>
  <fragment>
    <b-card :class="'main'">
      <img
        src="@/assets/media/logo.png"
        alt="Servicestart logo"
        class="d-none d-print-block"
        width="240"
        height="32"
        style="margin-bottom: 30px"
      />
      <h1 class="d-print-none">{{ $t('pages.payment_history.title') }}</h1>
      <p class="d-print-none" v-if="$t('pages.payment_history.body')">
        {{ $t('pages.payment_history.body') }}
      </p>

      <b-card :header="$t('user.payment.account_balance')" class="d-print-none">
        <b-list-group flush>
          <b-list-group-item
            ><h3>
              {{ (user.balance / 100) | currency(user.currency) }}
            </h3></b-list-group-item
          >
        </b-list-group>
      </b-card>

      <AccountHistoryTable />
    </b-card>

    <LoginForm v-if="!api_token" />
  </fragment>
</template>
<script>
import AccountHistoryTable from '../components/AccountHistoryTable.vue';

export default {
  components: {
    AccountHistoryTable,
  },
  metaInfo() {
    return {
      title: this.$t('pages.payment_history.title'),
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  data() {
    return {
      api_token: sessionStorage.getItem('api_token') || null,
    };
  },
};
</script>
